import toastVue from './index.vue'

// 定义插件对象
const CusToast = {}
// vue的install方法，用于定义vue插件
CusToast.install = function (Vue, options) {
  // 结局_t undefined 问题
  toastVue.i18n = window.i18n
  // 构造器创建子类组件
  const ToastInstance = Vue.extend(toastVue)
  // 定义当前组件对象
  let currentToast
  // 实例化挂在模板
  const initInstance = () => {
    // 实例化vue实例
    currentToast = new ToastInstance()
    const msgBoxEl = currentToast.$mount().$el
    document.body.appendChild(msgBoxEl)
  }
  // 在Vue的原型上添加实例方法，以全局调用
  window.$toast = Vue.prototype.$toast = {
    /**
         * 原生传参方法
         */
    originToast(options) {
      // 判断实例是否存在,并创建
      if (!currentToast) {
        initInstance()
      }
      // 合并对象
      if (typeof options === 'object') {
        Object.assign(currentToast, options)
      }
    },
    /**
         * 显示提示信息的方法
         */
    simpleShow(message, warnType, time = 3000, toastLinkName = '', callback) {
      // 判断实例是否存在,并创建
      if (!currentToast) {
        initInstance()
      }

      let hsLink = false
      let toastLink = ''
      // 判断是否含有点击超链接
      if (toastLinkName) {
        hsLink = true
        toastLink = toastLinkName
      }
      // 合并信息
      Object.assign(
        currentToast,
        {
          toastInfo: { info: message, tipsType: warnType },
          value: true,
          show: true,
          isIcon: false,
          time,
          isLink: hsLink,
          toastLink,
          hrefClick() {
            if (typeof callback === 'function') callback()
          },
        },
      )
    },
  }
}
export default CusToast
